(function () {
  'use strict';

  var FEE_TIERS = [
    { min: 1, max: 4999, rate: 13 },
    { min: 5000, max: 9999, rate: 10.4 },
    { min: 10000, max: 29999, rate: 6 },
    { min: 30000, max: 99999, rate: 4 },
    { min: 100000, max: Infinity, rate: 0 }
  ];

  var MONTH_DAYS = 28;

  function getRate(amount) {
    for (var i = 0; i < FEE_TIERS.length; i++) {
      if (amount >= FEE_TIERS[i].min && amount <= FEE_TIERS[i].max) {
        return FEE_TIERS[i].rate;
      }
    }
    return 0;
  }

  function formatDate(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function formatCZK(value) {
    return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
  }

  function daysBetween(d1, d2) {
    var ms = d2.getTime() - d1.getTime();
    return Math.max(0, Math.round(ms / 86400000));
  }

  function init() {
    var container = document.querySelector('[data-zastavy-calculator]');
    if (!container) return;

    var amountInput = container.querySelector('[data-calc-amount]');
    var startInput = container.querySelector('[data-calc-start]');
    var endInput = container.querySelector('[data-calc-end]');

    var outDays = container.querySelector('[data-calc-out-days]');
    var outAmount = container.querySelector('[data-calc-out-amount]');
    var outTotal = container.querySelector('[data-calc-out-total]');
    var outDaily = container.querySelector('[data-calc-out-daily]');
    var outIndividual = container.querySelector('[data-calc-out-individual]');

    // Set default dates
    var today = new Date();
    var defaultEnd = new Date(today);
    defaultEnd.setDate(defaultEnd.getDate() + MONTH_DAYS);

    startInput.value = formatDate(today);
    endInput.value = formatDate(defaultEnd);
    startInput.min = formatDate(today);

    function calculate() {
      var amount = parseInt(amountInput.value, 10) || 0;
      var startDate = new Date(startInput.value);
      var endDate = new Date(endInput.value);

      // Update end min based on start
      endInput.min = startInput.value;
      if (endDate <= startDate) {
        var newEnd = new Date(startDate);
        newEnd.setDate(newEnd.getDate() + MONTH_DAYS);
        endInput.value = formatDate(newEnd);
        endDate = newEnd;
      }

      var totalDays = daysBetween(startDate, endDate);
      outDays.textContent = totalDays;

      if (amount <= 0) {
        outAmount.textContent = '— Kč';
        outTotal.textContent = '— Kč';
        outDaily.textContent = '— Kč';
        if (outIndividual) outIndividual.style.display = 'none';
        return;
      }

      outAmount.textContent = formatCZK(amount);

      // Check individual pricing
      if (amount >= 100000) {
        outTotal.textContent = 'individuální';
        outDaily.textContent = 'individuální';
        if (outIndividual) outIndividual.style.display = '';
        return;
      }

      if (outIndividual) outIndividual.style.display = 'none';

      var rate = getRate(amount);

      // Fee = (rate/100) * amount * (totalDays / 28)
      var fee = (rate / 100) * amount * (totalDays / MONTH_DAYS);
      var dailyFee = totalDays > 0 ? fee / totalDays : 0;

      outTotal.textContent = formatCZK(fee);
      outDaily.textContent = 'pouze ' + formatCZK(dailyFee);
    }

    amountInput.addEventListener('input', calculate);
    startInput.addEventListener('change', calculate);
    endInput.addEventListener('change', calculate);

    calculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
